export default {  
    SET_COMPLETIONTABLE: (state, payload) => state.completionTable = payload,
  }